import { createReducer, on, Action } from '@ngrx/store';

import * as ApplicationActions from './application.actions';
import { MediaQuerySizeType } from './application.models';
import { EnvironmentUpdateEnum } from '@ap-angular/shared/environment';

export const APPLICATION_FEATURE_KEY = 'application';

export interface State {
	appLanguage: string;
	mediaQuerySize: MediaQuerySizeType;
	sidenav: string;
	showSearch: boolean;
	versionUpdate: EnvironmentUpdateEnum;
	version: string;
	positionOfSearchInput: number;
}

export interface ApplicationPartialState {
	readonly [APPLICATION_FEATURE_KEY]: State;
}

export const initialState: State = {
	appLanguage: undefined,
	mediaQuerySize: undefined,
	sidenav: undefined,
	showSearch: false,
	versionUpdate: undefined,
	version: undefined,
	positionOfSearchInput: undefined
};

const applicationReducer = createReducer(
	initialState,
	on(ApplicationActions.VersionAction, (state, {payload: {version, versionUpdate}}) => ({...state, version, versionUpdate})),
	on(ApplicationActions.MediaQuerySizeChanged, (state, {mediaQuerySize}) => ({...state, mediaQuerySize})),
	on(ApplicationActions.AppLanguage, (state, {language}) => ({...state, language})),
	on(ApplicationActions.AppSidenav, (state, {sidenav}) => ({...state, sidenav})),
	on(ApplicationActions.ShowSearch, (state, {showSearch}) => ({...state, showSearch})),
	on(ApplicationActions.ClearState, () => ({...initialState})),
	on(ApplicationActions.PositionOfSearchInput, (state, {positionOfSearchInput}) => ({...state, positionOfSearchInput}))
);

export function reducer(state: State | undefined, action: Action) {
	return applicationReducer(state, action);
}
